// extracted by mini-css-extract-plugin
export default {"root":"PercentageField_root__Bc5Z6"};